import { selector } from 'recoil';
import { countOrderProductsByType } from '../../helpers/product-count-by-type.js';
import shoppingCartState from './shopping-cart-state.js';
const shoppingCartProductCountState = selector({
    key: 'shoppingCartProductCount',
    get: ({ get }) => {
        const shoppingCart = get(shoppingCartState.response);
        return countOrderProductsByType({
            order: shoppingCart?.ShoppingCart,
        });
    },
});
export default shoppingCartProductCountState;
//# sourceMappingURL=shopping-cart-product-count-state.js.map